import React from 'react';
import { useFormTab } from '~/pages/CardSaga/components/providers/FormTabProvider';
import ConnectStatusDetail from './ConnectStatusDetail';

function StatusDetail() {
    const { cardMetaData } = useFormTab();
    const { statuses } = cardMetaData;

    return <ConnectStatusDetail statuses={statuses} />;
}

export default StatusDetail;
